import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Breadcrumbs } from '../../../components'
import { useDispatch } from 'react-redux'
import Users from '../../users/UsersPage'
import { fetchAllUsersThunk } from '../../../redux/features/user/userThunk'
import { selectAllUsers } from '../../../redux/features/user/userSelectors'
import { AppDispatch } from '../../../redux/store/store'

const UsersPage = () => {
  const dispatch = useDispatch<AppDispatch>()
  const users = useSelector(selectAllUsers)
  useEffect(() => {
    dispatch(fetchAllUsersThunk())
  }, [dispatch])

  return (
    <div>
      <Breadcrumbs />
      <Users users={users} />
    </div>
  )
}

export { UsersPage }
